export const SIDEBAR_CONSTANTS = {
  ACTIONS: {
    LOGOUT: "logout",
  },
  CALANDER_ROUTE: "/admin/calander",
  EIGHTH_ROW: "Category Management",
  ELEVENTH_ROW: "Calendar",
  FIFTEENTH_ROW: "Tabs",
  FIFTH_ROW: "Applications",
  FIRST_ROW: "Dashboard",
  FOURTEENTH_ROW: "Sign Out",
  FOURTH_ROW: "Jobs",
  MODULE_ID: {
    APPLICATIONS: "applications",
    CALENDAR: "calendar",
    CATEGORY_MANAGEMENT: "category_management",
    JOBS: "jobs",
    NOTES: "notes",
    NOTIFICATIONS: "notifications",
    OFFICES: "dental_offices",
    PAY_RANGE_AND_BILL_RATES: "pay_range_and_bill_rates",
    PROSPECTS: "prospects",
    PROFESSIONALS: "dental_professionals",
    REFERRAL_MANAGEMENT: "referral_management",
    REVENUE_REPORT: "revenue_report",
    ROLE_MANAGEMENT: "role_management",
    TIMESHEETS: "timesheets_and_timesheet_dispute",
  },
  NINTH_ROW: "Timesheet",
  NOTIFICATION_URL: "/admin/notification",
  NOTIFICATION: "Notifications",
  PATH_LENGTH_CHECKING_NEGATIVE: -1,
  PAY_RANGE_AND_BILL_RATES_URL: "/admin/pay-range-bill-rate",
  PAY_RANGE_AND_BILL_RATES: "Pay Range and Bill Rates",
  PAY_RANGE_STANDARD_PRICING_URL: "/admin/pay-range-bill-rate",
  PAY_RANGE_TRANSPARENCY_MODEL_URL:
    "/admin/pay-range-bill-rate/transparency-model",
  PAY_RANGE_REFERRAL_JOB_URL: "/admin/pay-range-bill-rate/referral-job",
  PAY_RANGE_BULK_HIRE_URL: "/admin/pay-range-bill-rate/bulk-hire",
  PROSPECTS: "Prospects",
  REFERRAL_ROUTE: "/admin/referral",
  REPORT_ROUTE: "/admin/reports",
  REVENUE_REPORT_URL: "/admin/revenue-report",
  REVENUE_REPORT: "Revenue Report",
  ROLE_MANAGEMENT: "/admin/role-management",
  ROUTE_APPLICATION: "/admin/job-application",
  ROUTE_DASHBOARD: "/admin/dashboard",
  ROUTE_JOB: "/admin/jobs",
  ROUTE_NOTES: "/admin/notes",
  ROUTE_STATEMENT: "/admin/statement",
  ROUTE_OFFICE_USERS: "/admin/office-users",
  ROUTE_PROFESSIONAL_USERS: "/admin/professional-users",
  ROUTE_PROSPECTS: "/admin/prospects",
  ROUTE_INVOICE: "/admin/invoice",
  ROUTE_SETTINGS: "/admin/settings",
  ROUTE_TABS: "/admin/category",
  SECOND_ROW: "Dental Offices",
  SEVENTH_ROW: "Role Management",
  SIDEBAR_SPLIT_PATH: "/",
  SIXTH_ROW: "Invoice",
  STATEMENT: "Statement",
  TENTH_ROW: "Ratings",
  THIRD_ROW: "Dental Professionals",
  THIRTEENTH_ROW: "Settings",
  TIMESHEET_ROUTE: "/admin/timesheet",
  TWELVETH_ROW: "Help",
  INVOICE: "invoices",
  PROSPECTS_ROUTE: "prospects",
  JOB_ROUTE: "jobs",
  ROUTE_JOB_ASSIGNMENTS: "/admin/jobs-assignments",
  ROUTE_JOB_CANCELLED: "/admin/jobs-cancelled",
  ROUTE_JOB_BULK_CONVERSION: "/admin/jobs-bulk-conversion",
};
